module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/check/example-8f2813.svg";